import classNames from 'classnames/bind';

import styles from './Timeline.pcss';

const cx = classNames.bind(styles);

const Timeline = ({ children }: { children: React.ReactNode }): React.ReactElement => (
  <div className={cx('timeline')}>{children}</div>
);

export default Timeline;
